import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

export const spaceCollectionAvatarValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (!value) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  return null;
};
